
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ticky",
      function () {
        return require("private-next-pages/ticky.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ticky"])
      });
    }
  